import React from 'react';
import { Link, withRouter } from "react-router-dom"
import {Input,Form,FormGroup,Label} from "reactstrap";
import { getStorageUser } from '../../helpers/api_helper';
import {Alert,ConfirmAsistencia} from '../../helpers/alerts/alertHelper';
import { resourcesAttendances } from '../../helpers/backend_helper';

const Columns = (attendanceModal,setAttendanceModal,setFilters,filters,datesDays) => {
	const days=[
		'Domingo',
		'Lunes',
		'Martes',
		'Miercoles',
		'Jueves',
		'Viernes',
		'Sabado',
		];

	const changeStatus = (date,id,status) => {
    	let data = {
			date:date,
			id:id,
			attendance:status
	    }
    	ConfirmAsistencia(async confirmed => {
            if (!confirmed) { return; }
            resourcesAttendances('post',data).then(response => {
    			setFilters({...filters,week:filters.week})
    		})
        },status);
    }

	

	let col = [
		{
			id: 'name',
			name: 'Nombre',
			selector: row => row.full_name,
			sortable: true,
			wrap: true,
			width:'20%'
		},
	]
//item:row,date:row.days['Domingo'].date,day:'Domingo'}
	days.map(d=>(
		col.push({
			id: d,
			name: (<>{d == 'Miercoles' ? 'Miércoles' : (d == 'Sabado'?'Sábado':d)}<br />{datesDays[d]}</>),
			width:'10%',
			button: true,
			cell: row => (
				<div className="d-flex justify-content-between">
					<div className="p-2">
						{(row.days[d].att ? row.days[d].att.attendance:0) ?
							<button onClick={() => changeStatus(row.days[d].date,row.id,0)} className="btn btn-success btn-sm" title='Asistencia'><i className="fa fa-check-circle fa-1x"></i></button> 
						:
							<button onClick={() => changeStatus(row.days[d].date,row.id,1)} className={"btn btn-danger btn-sm"} title={"Inasistencia"}>
								<i className={"fa fa-times-circle fa-1x" }></i>
							</button>
						}
					</div>
				</div>
			),
		})
	))


	

	let columns = col
	return columns;
}

export default Columns;